module.exports = __webpack_public_path__ + "img/icon-email.38f5d95b.svg";